import { render, staticRenderFns } from "./PropMutliSelect.vue?vue&type=template&id=30119656&scoped=true&"
import script from "./PropMutliSelect.vue?vue&type=script&lang=js&"
export * from "./PropMutliSelect.vue?vue&type=script&lang=js&"
import style0 from "./PropMutliSelect.vue?vue&type=style&index=0&id=30119656&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30119656",
  null
  
)

export default component.exports